import { createSlice } from "@reduxjs/toolkit";
import { 
  fetchSubscriptionPlanTableColumns,
  fetchAllSubscriptionPlans,
  addSubscriptionPlan,
  updateSubscriptionPlan,
  deleteSubscriptionPlan,
  activateDeactivateSubscriptionPlan,
  fetchSubscriptionPlanById,
  fetchSubscriptionPlanFeatures,
  fetchSubscriptionPlanTags
} from "./thunk";

const initialState = {
  plans: [],
  selectedPlan: {
    ID: null,
    NameEn: "",
    NameAr: "",
    DescriptionEn: "",
    DescriptionAr: "",
    PlanCode: "",
    CountryID: 113,
    Price: 0,
    BillingCycle: "MONTHLY",
    Modules: [],
    Limits: []
  },
  features: [],
  tags: [],
  tableColumnNames: [],
  loading: false,
  error: null,
};

const SubscriptionPlanSlice = createSlice({
  name: "SubscriptionPlans",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchSubscriptionPlanTableColumns.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchSubscriptionPlanTableColumns.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchSubscriptionPlanTableColumns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchAllSubscriptionPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchAllSubscriptionPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
    })
    .addCase(fetchAllSubscriptionPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(addSubscriptionPlan.pending, (state) => {
        state.error = null;
    })
    .addCase(addSubscriptionPlan.fulfilled, (state, action) => {
        state.plans.unshift(action.payload);
    })
    .addCase(addSubscriptionPlan.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateSubscriptionPlan.pending, (state) => {
        state.error = null;
    })
    .addCase(updateSubscriptionPlan.fulfilled, (state, action) => {
        const index = state.plans.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.plans[index] = action.payload;
        }
    })
    .addCase(updateSubscriptionPlan.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteSubscriptionPlan.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteSubscriptionPlan.fulfilled, (state, action) => {
        state.plans = state.plans.filter(
            (item) => item.ID !== action.payload[0].ID
        );
    })
    .addCase(deleteSubscriptionPlan.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateSubscriptionPlan.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateSubscriptionPlan.fulfilled, (state, action) => {
        const index = state.plans.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.plans[index] = { ...state.plans[index], IsActive: action.payload.IsActive };
        }
    })
    .addCase(activateDeactivateSubscriptionPlan.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(fetchSubscriptionPlanById.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchSubscriptionPlanById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPlan = action.payload;
    })
    .addCase(fetchSubscriptionPlanById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchSubscriptionPlanFeatures.pending, (state) => {
        state.error = null;
    })
    .addCase(fetchSubscriptionPlanFeatures.fulfilled, (state, action) => {
        state.features = action.payload;
    })
    .addCase(fetchSubscriptionPlanFeatures.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(fetchSubscriptionPlanTags.pending, (state) => {
        state.error = null;
    })
    .addCase(fetchSubscriptionPlanTags.fulfilled, (state, action) => {
        state.tags = action.payload;
    })
    .addCase(fetchSubscriptionPlanTags.rejected, (state, action) => {
        state.error = action.payload;
    })
  },
});

export default SubscriptionPlanSlice.reducer;
